import styled, { css } from "styled-components";

interface ListStyleProps {
  $overflowX?: boolean;
  $direction?: "row" | "column";
  $gridColumns?: string;
  $gap?: number | string;
  $left?: string;
}

export const List = styled.ul<ListStyleProps>`
  // 가로형 리스트, overflow 가로 스크롤 있음
  ${(props) =>
    props.$overflowX === true &&
    css`
      overflow: auto;
      position: relative;
      display: ${props.$gridColumns ? "grid" : "flex"};
      width: calc(100vw);
      left: ${props.$left};
      padding: 0 16px;
      align-items: center;
      gap: 8px;

      // 격자형 배열일 때
      ${props.$gridColumns
        ? css`
            overflow: auto;
            grid-template-columns: ${props.$gridColumns};

            &::-webkit-scrollbar {
              display: none;
            }
          `
        : css`
            // 병렬형 배열일 때(가로/세로)
            flex-direction: ${props.$direction};
          `}

      &::-webkit-scrollbar {
        display: none;
      }
    `}

  // overflow 가로 스크롤 없음
  ${(props) =>
    props.$overflowX === false &&
    css`
      display: ${props.$gridColumns ? "grid" : "flex"};
      width: 100%;
      align-items: center;
      gap: ${props.$gap}px;

      // 격자형 배열일 때
      ${props.$gridColumns
        ? css`
            overflow: hidden;
            grid-template-columns: ${props.$gridColumns};

            &::-webkit-scrollbar {
              display: none;
            }
          `
        : css`
            // 병렬형 배열일 때(가로/세로)
            flex-direction: ${props.$direction};
          `}
    `}
`;
